module.exports = __webpack_public_path__ + "static/img/licesence-02.52eed21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/licesence-02.jpg
// module id = VTYG
// module chunks = 1